module.exports = __webpack_public_path__ + "assets/img/a7eef595868b9fc5543c86e08a608b02.png";